import { Table } from "antd";
import React from "react";
import ReportChemicalVolumeTable from "./components/ReportChemicalVolumeTable";

const TMReportChemVolume = () => {
  return <ReportChemicalVolumeTable />;
};

export default TMReportChemVolume;
